import api from '@/apis'
import Vuetify from '@/plugins/vuetify'

export default {
  state: {
    visibility: false,
    menu_visibility: true,
    detail_loading: false,
    random_pick_loading: false,
    number_loading: false,
    title_loading: false,
    order_loading: false,

    is_submit_disable: false,

    selected_quiz_id: null,
    quiz_library: [],
    quiz_detail: {},
    motions: {
      action_gesture: ['m01.motion3.json', 'm02.motion3.json', 'm03.motion3.json', 'm04.motion3.json', 'm05.motion3.json'],
      idle_motion: ['idle01.motion3.json', 'idle02.motion3.json', 'idle03.motion3.json'],
      lip_sync_animation: false
    }
  },
  mutations: {
    INIT_QUIZ_LIBRARY_DIALOG(state) {
      state.visibility = true
    },
    RESET_QUIZ_LIBRARY_DIALOG(state) {
      state.visibility = false
      state.selected_quiz_id = null
      state.quiz_detail = {}
    },
    SET_QUIZ_LIBRARY_DIALOG_MENU_VISIBILITY(state, payload) {
      state.menu_visibility = payload
    },
    SET_QUIZ_LIBRARY_DIALOG_DETAIL_LOADING(state, payload) {
      state.detail_loading = payload
    },
    SET_QUIZ_LIBRARY_DIALOG_RANDOM_PICK_LOADING(state, payload) {
      state.random_pick_loading = payload
    },
    SET_QUIZ_LIBRARY_DIALOG_NUMBER_LOADING(state, payload) {
      state.number_loading = payload
    },
    SET_QUIZ_LIBRARY_DIALOG_TITLE_LOADING(state, payload) {
      state.title_loading = payload
    },
    SET_QUIZ_LIBRARY_DIALOG_ORDER_LOADING(state, payload) {
      state.order_loading = payload
    },
    SET_QUIZ_LIBRARY_DIALOG_IS_SUBMIT_DISABLE(state, payload) {
      state.is_submit_disable = payload
    },
    SET_QUIZ_LIBRARY_DIALOG_SELECTED_QUIZ_ID(state, payload) {
      state.selected_quiz_id = payload
    },
    SET_QUIZ_LIBRARY_DIALOG_QUIZ_LIBRARY(state, payload) {
      state.quiz_library = payload
    },
    SET_QUIZ_LIBRARY_DIALOG_QUIZ_DETAIL(state, payload) {
      state.quiz_detail = payload
    },
    RENAME_QUIZ_LIBRARY_DIALOG_QUIZ(state, payload) {
      const index = state.quiz_library.findIndex((quiz) => quiz.quiz_id === state.selected_quiz_id)
      state.quiz_library[index].quiz_name = payload.name
      state.quiz_library[index].languages = payload.languages
    }
  },
  actions: {
    async fetchQuizLibrary({ commit }) {
      try {
        commit('SET_QUIZ_LIBRARY_DIALOG_MENU_VISIBILITY', false)
        commit('SET_QUIZ_LIBRARY_DIALOG_QUIZ_LIBRARY', [])
        const response = await api.getQuizLibraryList()
        if (response.data.success) {
          commit('SET_QUIZ_LIBRARY_DIALOG_QUIZ_LIBRARY', response.data.data)
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_QUIZ_LIBRARY_DIALOG_MENU_VISIBILITY', true)
      }
    },
    async addQuizLibrary({ rootState, commit, dispatch }, payload) {
      try {
        const device_id = rootState.auth.selected_device

        const response = await api.createQuiz({ params: { device_id, ...payload } })
        if (response.data.success) {
          dispatch('fetchQuizLibrary')
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      }
    },
    async duplicateQuiz({ rootState, commit, dispatch }, payload) {
      try {
        const device_id = rootState.auth.selected_device
        const response = await api.duplicateQuiz({ quiz_id: payload, params: { device_id } })
        if (response.data.success) {
          dispatch('fetchQuizLibrary')
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      }
    },
    async fetchQuizDetail({ commit }, payload) {
      try {
        commit('SET_QUIZ_LIBRARY_DIALOG_DETAIL_LOADING', true)
        commit('SET_QUIZ_LIBRARY_DIALOG_QUIZ_DETAIL', {})

        const response = await api.getQuizDetail({ quiz_id: payload })
        if (response.data.success) {
          commit('SET_QUIZ_LIBRARY_DIALOG_SELECTED_QUIZ_ID', payload)
          commit('SET_QUIZ_LIBRARY_DIALOG_QUIZ_DETAIL', response.data.data)
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_QUIZ_LIBRARY_DIALOG_DETAIL_LOADING', false)
      }
    },
    async updateQuizDetail({ rootState, state, commit, dispatch }, payload) {
      try {
        if (payload.type === 'random_pick') commit('SET_QUIZ_LIBRARY_DIALOG_RANDOM_PICK_LOADING', true)
        else if (payload.type === 'number') commit('SET_QUIZ_LIBRARY_DIALOG_NUMBER_LOADING', true)
        else if (payload.type === 'title') commit('SET_QUIZ_LIBRARY_DIALOG_TITLE_LOADING', true)
        else if (payload.type === 'order') commit('SET_QUIZ_LIBRARY_DIALOG_ORDER_LOADING', true)

        commit('SET_SNACKBAR', { status: true, color: 'loading', text: Vuetify.locale.t('$vuetify.__SnackBar.updating', ''), loading: true })

        const device_id = rootState.auth.selected_device
        const response = await api.updateQuizDetail({ quiz_id: payload.quiz_id, params: { device_id, ...payload.params } })
        if (response.data.success) {
          commit('SET_SNACKBAR', { status: true, color: 'success', text: Vuetify.locale.t('$vuetify.__SnackBar.update', ''), icon: 'check', timeout: '2000' })
          if (payload.type === 'title') {
            dispatch('fetchQuizLibrary')
            dispatch('fetchQuizDetail', state.quiz_detail.id)
          }
        } else {
          let old_value = !state.quiz_detail.is_enabled_random_pick
          state.quiz_detail.is_enabled_random_pick = old_value
          throw Error(response.data.message)
        }
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_QUIZ_LIBRARY_DIALOG_RANDOM_PICK_LOADING', false)
        commit('SET_QUIZ_LIBRARY_DIALOG_NUMBER_LOADING', false)
        commit('SET_QUIZ_LIBRARY_DIALOG_TITLE_LOADING', false)
        commit('SET_QUIZ_LIBRARY_DIALOG_ORDER_LOADING', false)
      }
    }
  }
}
